import { render, staticRenderFns } from "./TradingViewChart.vue?vue&type=template&id=fcc5b34c&scoped=true"
import script from "./TradingViewChart.vue?vue&type=script&lang=js"
export * from "./TradingViewChart.vue?vue&type=script&lang=js"
import style0 from "./TradingViewChart.vue?vue&type=style&index=0&id=fcc5b34c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcc5b34c",
  null
  
)

export default component.exports